import { Grid, Text } from "designSystem/index";
import React from "react";

export default () => (
	<Grid
		container
		direction="column"
		spacing={3}
		style={{ textAlign: "left" }}
	>
		<Grid item>
			<Text text="h1: 今天的天气不错，比较适合约几个朋友外出郊游，晒晒太阳，聊聊天。" variant="h1" />
		</Grid>
		<Grid item>
			<Text text="h2: 今天的天气不错，比较适合约几个朋友外出郊游，晒晒太阳，聊聊天。" variant="h2" />
		</Grid>
		<Grid item>
			<Text text="h3: 今天的天气不错，比较适合约几个朋友外出郊游，晒晒太阳，聊聊天。" variant="h3" />
		</Grid>
		<Grid item>
			<Text text="h4: 今天的天气不错，比较适合约几个朋友外出郊游，晒晒太阳，聊聊天。" variant="h4" />
		</Grid>
		<Grid item>
			<Text text="h5: 今天的天气不错，比较适合约几个朋友外出郊游，晒晒太阳，聊聊天。" variant="h5" />
		</Grid>
		<Grid item>
			<Text text="h6: 今天的天气不错，比较适合约几个朋友外出郊游，晒晒太阳，聊聊天。" variant="h6" />
		</Grid>
		<Grid item>
			<Text text="subtitle1: 今天的天气不错，比较适合约几个朋友外出郊游，晒晒太阳，聊聊天。" variant="subtitle1" />
		</Grid>
		<Grid item>
			<Text text="subtitle2: 今天的天气不错，比较适合约几个朋友外出郊游，晒晒太阳，聊聊天。" variant="subtitle2" />
		</Grid>
		<Grid item>
			<Text text="body1: 今天的天气不错，比较适合约几个朋友外出郊游，晒晒太阳，聊聊天。" variant="body1" />
		</Grid>
		<Grid item>
			<Text text="body2: 今天的天气不错，比较适合约几个朋友外出郊游，晒晒太阳，聊聊天。" variant="body2" />
		</Grid>
		<Grid item>
			<Text text="button: 今天的天气不错，比较适合约几个朋友外出郊游，晒晒太阳，聊聊天。" variant="button" />
		</Grid>
		<Grid item>
			<Text text="caption: 今天的天气不错，比较适合约几个朋友外出郊游，晒晒太阳，聊聊天。" variant="caption" />
		</Grid>
		<Grid item>
			<Text text="overline: 今天的天气不错，比较适合约几个朋友外出郊游，晒晒太阳，聊聊天。" variant="overline" />
		</Grid>
	</Grid>
);